import { apiRequest } from '@/services/axios'

interface Privileges {
    roles: string[]
    permissions: string[]
}

declare global {
    interface Window {
        meetspain: {
            privileges: Privileges | 0
        }
    }
}

class Permissions {
    is(value: string): boolean {
        if (window.meetspain.privileges === 0) return false

        const { roles } = window.meetspain.privileges
        let _return = false

        if (!Array.isArray(roles)) return false

        if (value.includes('|')) {
            value.split('|').forEach((item) => {
                if (roles.includes(item.trim())) {
                    _return = true
                }
            })
        } else if (value.includes('&')) {
            _return = true
            value.split('&').forEach((item) => {
                if (!roles.includes(item.trim())) {
                    _return = false
                }
            })
        } else {
            _return = roles.includes(value.trim())
        }

        return _return
    }

    can(value: string): boolean {
        if (window.meetspain.privileges === 0) return false

        const { roles, permissions } = window.meetspain.privileges
        let _return = false

        if (roles.includes('owner')) return true
        if (!Array.isArray(permissions)) return false

        if (value.includes('|')) {
            value.split('|').forEach((item) => {
                if (permissions.includes(item.trim())) {
                    _return = true
                }
            })
        } else if (value.includes('&')) {
            _return = true
            value.split('&').forEach((item) => {
                if (!permissions.includes(item.trim())) {
                    _return = false
                }
            })
        } else {
            _return = permissions.includes(value.trim())
        }

        return _return
    }

    async reloadRolesAndPermissions(): Promise<void> {
        const token = localStorage.getItem('authToken')

        if (token) {
            try {
                const response = await apiRequest(
                    'get',
                    '/auth/get-roles-and-permissions',
                    {},
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            'Accept-Language': 'en',
                        },
                    }
                )

                window.meetspain.privileges = response.data.data
            } catch (error) {}
        }
    }
}

const permissions = new Permissions()

export default {
    install: (app: any, options?: any) => {
        app.config.globalProperties.can = permissions.can.bind(permissions)
        app.config.globalProperties.is = permissions.is.bind(permissions)
    },
}

const is = permissions.is.bind(permissions)
const can = permissions.can.bind(permissions)
const reloadRolesAndPermissions = permissions.reloadRolesAndPermissions.bind(permissions)

export { is, can, reloadRolesAndPermissions }

window.meetspain = window.meetspain || {}
window.meetspain.privileges = window.meetspain.privileges || { permissions: [], roles: [] }